var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    stimulusPadding: spacing.large,
    headerPadding: spacing.small,
    stimulusContentPaddingTop: spacing.large,
    stimulusContentPaddingBottom: spacing.small,
    stimulusContentPaddingLeftRight: spacing.small
  };
};
export default generateComponentTheme;